import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import {
  Alert,
  CircularProgress,
  Grid,
  IconButton,
  Snackbar,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useState } from "react";
import axiosInstance from "../Utils/AxoisClient";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const defaultStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  display: "flex",
  justifyContent: "center",
  alignItem: "center",
  flexDirection: "column",
};

const centerStyle = {
  display: "flex",
  justifyContent: "center",
  alignItem: "center",
  // width: "100%",
  p: 1,
};
const buttonStyle = {
  marginTop: "30px",
};

export default function Popup({
  open,
  usedFor,
  img,
  handleClose,
  title = "Default Title",
  firstButton,
  secondButton,
  apiEndPoint,
  payload,
  style = defaultStyle,
  material_name,
  redirectPath,
  handleReload,
  children,
}) {
  const [value, setValue] = useState(material_name?.material_name);
  const [snackBar, setSnackBar] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [isConfirmStep, setIsConfirmStep] = useState(false);
  const [loading, setLoading] = React.useState(false);
  const navigate = useNavigate();
  // const handleFirstButtonClick = async () => {
  //   const payloadValue = {
  //     ...payload,
  //     bookmark_title: value,
  //   };
  //   try {
  //     const response = await axiosInstance.post(apiEndPoint, payloadValue);
  //     if (response.data.message == "Bookmark Create successfully!") {
  //       alert("Bookmark Create successfully!");
  //       navigate("/bookmark-data");
  //     }
  //   } catch (error) {

  //   }
  // };

  const handleFirstButtonClick = async (
    endpoint,
    payload,
    redirectPath,
    valueKey = "bookmark_title",
    value
  ) => {
    setLoading(true);
    try {
      const payloadValue = value ? { ...payload, [valueKey]: value } : payload;
      const response = await axiosInstance.post(endpoint, payloadValue);
      if (response?.data?.message) {
        setSnackBar(true);
        setAlertMessage(response?.data?.message);
        if (redirectPath) {
          setTimeout(() => {
            navigate(redirectPath);
            handleClose();
          }, 1000);
          redirectPath === "/bookmark-data" &&
            usedFor === "delete" &&
            handleReload();
        }
        // if (response?.data?.message?.toLowerCase().includes("already exist")) {
        setTimeout(() => {
          // navigate(redirectPath);
          handleClose();
        }, 1500);
        setLoading(false);
        //  handleClose();
      } else {
        alert(response || "Something went wrong!");
        setLoading(false);
      }
    } catch (error) {
      const backendMessage = error?.response?.data?.message || error.message;
      if (backendMessage?.toLowerCase().includes("already exist")) {
        setIsConfirmStep(true);
        setLoading(false);
        return;
      }
      setLoading(false);
      toast.error(backendMessage, { autoClose: 5000 });
      // alert(backendMessage);
    }
  };

  return (
    <>
      <Snackbar
        open={snackBar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        key={"top" + "right"}
        autoHideDuration={6000}
        onClose={() => setSnackBar(false)}
      >
        <Alert
          onClose={() => setSnackBar(false)}
          severity="success"
          variant="filled"
          sx={{ width: "100%" }}
        >
          {alertMessage}
        </Alert>
      </Snackbar>
      <div>
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-title"
          aria-describedby="modal-description"
        >
          <Box sx={style}>
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{ position: "absolute", right: 8, top: 8 }}
            >
              <CloseIcon />
            </IconButton>

            <Box style={centerStyle}>
              <img src={img} alt="icon" />
            </Box>

            <Typography
              id="modal-title"
              variant="h6"
              component="h2"
              sx={centerStyle}
            >
              {isConfirmStep ? "Already Exists" : title}
            </Typography>

            {isConfirmStep ? (
              <Box sx={{ textAlign: "center", mt: 2 }}>
                <Typography>
                  This item already exists.Do you want to proceed anyway?
                </Typography>
              </Box>
            ) : usedFor !== "delete" ? (
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  value={value}
                  onChange={(e) => setValue(e.target.value)}
                  InputProps={{
                    sx: {
                      fontWeight: "bold",
                      fontSize: "18px",
                      input: { textAlign: "center" },
                    },
                  }}
                />
              </Box>
            ) : (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  justifyContent: "center",
                }}
              >
                {typeof material_name === "object"
                  ? material_name?.material_name || material_name?.name || "-"
                  : material_name || "-"}
              </Box>
            )}

            <Box sx={buttonStyle}>
              <Grid
                container
                spacing={2}
                style={{
                  ...centerStyle,
                  justifyContent: "space-between",
                  padding: 1,
                }}
              >
                <Grid item lg={6}>
                  <Button
                    variant="contained"
                    onClick={() => {
                      if (isConfirmStep) {
                        // Proceed anyway
                        handleFirstButtonClick(
                          apiEndPoint,
                          { ...payload, is_override: true },
                          redirectPath,
                          "bookmark_title",
                          value
                        );
                        setIsConfirmStep(false);
                      } else {
                        const updatedPayload =
                          usedFor === "edit"
                            ? { ...payload, request_type: "create" }
                            : payload;
                        handleFirstButtonClick(
                          apiEndPoint,
                          updatedPayload,
                          redirectPath,
                          "bookmark_title",
                          value
                        );
                      }
                    }}
                    sx={{
                      background:
                        usedFor !== "delete" ? "#7847DC" : "#ff2018ff",
                      textTransform: "none",
                      width: "100% !important",
                    }}
                  >
                    {/* {loading ? (
                      <CircularProgress size={20} sx={{ color: "white" }} />
                    ) : isConfirmStep ? (
                      "Proceed"
                    ) : (
                      firstButton
                    )} */}
                    {isConfirmStep ? (
                      "Proceed"
                    ) : loading ? (
                      <CircularProgress size={20} sx={{ color: "white" }} />
                    ) : (
                      firstButton
                    )}
                  </Button>
                </Grid>
                <Grid item lg={6}>
                  <Button
                    variant="contained"
                    sx={{ textTransform: "none", width: "100% !important" }}
                    onClick={() => {
                      if (isConfirmStep) {
                        setIsConfirmStep(false); // cancel confirmation, go back
                      } else if (usedFor === "edit") {
                        const updatedPayload = {
                          ...payload,
                          request_type: "update",
                        };
                        handleFirstButtonClick(
                          apiEndPoint,
                          updatedPayload,
                          redirectPath,
                          "bookmark_title",
                          value
                        );
                      } else if (usedFor === "bookMarkCreate") {
                        handleFirstButtonClick(
                          apiEndPoint,
                          payload,
                          "",
                          "bookmark_title",
                          value
                        );
                      } else {
                        handleClose();
                      }
                    }}
                  >
                    {/* {loading ? (
                      <CircularProgress size={20} sx={{ color: "white" }} />
                    ) : isConfirmStep ? (
                      "Cancel"
                    ) : (
                      secondButton
                    )} */}
                    {isConfirmStep ? "Cancel" : secondButton}
                  </Button>
                </Grid>
              </Grid>
            </Box>

            {children}
          </Box>
        </Modal>
      </div>
    </>
  );
}
